import TipsTricks from "../components/TipsTricks";
import { useTips } from "../hooks/useTips";

export interface TipsTricksScreenProps {
  token: string | null;
  loaderStatus: (status: boolean) => void;
}

/**
 * Business-logic container for the Tips & Tricks screen. Data loading and the
 * Type/Title filtering live in `useTips`; this wires state and handlers to the
 * presentational `TipsTricks` component.
 */
const TipsTricksScreen = ({ token, loaderStatus }: TipsTricksScreenProps) => {
  const {
    isLoading,
    allTips,
    titles,
    description,
    typeId,
    descId,
    setTypeId,
    setDescId,
  } = useTips(token, loaderStatus);

  return (
    <TipsTricks
      isLoading={isLoading}
      allTips={allTips}
      titles={titles}
      description={description}
      typeId={typeId}
      descId={descId}
      onTypeChange={setTypeId}
      onDescChange={setDescId}
    />
  );
};

export default TipsTricksScreen;
